const e=Object.freeze({form:"c-contact-form"}),t=Object.freeze({heading:"Contact us"}),a={email:"",message:"",firstName:"",lastName:"",phoneNumber:""};export{e as CONTACT_FORM_BLOCK_CSS_IDENTIFIERS,t as CONTACT_FORM_DEFAULTS,a as CONTACT_FORM_INITIAL_VALUES};
//# sourceMappingURL=ContactForm.constants.js.map
